import cn from "classnames";
import { isAddress } from 'ethers';
import React from "react";
import { Loader } from '../../../components/Loader';

const TransferModalButton = ({
  handleApprove,
  referralAddress,
  approve,
  isLoading,
  handleProceed,
	...props
}) => {
  return (
    <button
      type="button"
      {...props}
      onClick={() => {
        if (!approve) {
          handleApprove(referralAddress);
          return;
        }
        handleProceed(referralAddress);
      }}
      className={cn(
        "w-full p-2 md:p-4 flex items-center justify-center transition-all duration-300 border border-transparent dark:text-semiWhite dark:bg-[#1D1C2D] dark:border dark:border-white rounded-lg bg-iceBlue text-base leading-6 font-medium text-lightBlack",
        {
          "border border-white !bg-deepBlue !text-white shadow-swapButton":
            isAddress(referralAddress) && !props.disabled && !isLoading,
        }
      )}
    >
      {isLoading ? <Loader ratio={24} /> : approve ? "Transfer" : "Approve"}
    </button>
  );
};

export default TransferModalButton;
